import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import NavBar from '../components/NavBar';
import Publications from '../components/Publications';

class ResearchPage extends React.Component {
  render() {
    return (
      <div className="container"> 
        <NavBar activeKey="research" />
        <Row className="mb-4"/>
        <Row>
          <Col className="xs-12">
            <center>
            <img src="./files/WHISK.png" alt="WHISK logo: Workflows for Humanistic Understanding of Statistical Knowledge. Two crossed whisks with an arch over it of the full group name and WHISK written below."/>
            </center>
            <p>My research group works on questions of how to make it easier for experts in text collections, particularly those in the humanities and social sciences, to start using text mining tools. Currently, this work specifically focuses on user interface design to train and interact with topic models with a low barrier to entry.</p>

            <p>In addition to projects on lowering this barrier to entry, I also am a founding member of Pomona/HMC's <a href="https://sites.google.com/g.hmc.edu/econtext/">EconText Lab</a>, which studies ways to use large-scale text analysis tools to approach economics questions.</p>

            <h2>Past Work</h2>
            <br />
            <Publications />

            <br/><br/>
            
            <Card variant='secondary'>
              <Card.Header><h2>Notes</h2></Card.Header>
              <Card.Body>
              <Card.Text>
                I publish under Alexandra Schofield, but prefer Xanda Schofield in person.
              </Card.Text><Card.Text>
                * Uncited but relevant to this paper is Raphael Cohen et al.'s 2014 PLoS One paper,  <Card.Link href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3923754/">Redundancy-Aware Topic Modeling for Patient Record Notes</Card.Link>, which develops a topic model, Red-LDA, that aims to combat the effects of text duplication.
              </Card.Text><Card.Text>
                ** This work focuses on solely English, a fact which the title does not specify. While the analysis methodologies should generalize to other languages, the results discouraging stemming may not. See Chandler May et al.'s 2016 arXiv paper <Card.Link href="https://arxiv.org/abs/1608.03995">Analysis of Morphology in Topic Modeling</Card.Link> for an example of a somewhat different result in Russian.
              </Card.Text><Card.Text>
                *** This paper uses a version of gender analysis (assuming binary genders and classifying gender using common baby name lists) that I would not recommend due to its lack of gender inclusiveness and inaccuracy. For a better approach, check out Brian Larson's 2017 EthNLP paper, <Card.Link href="https://www.aclweb.org/anthology/W17-1601">Gender as a Variable in Natural-Language Processing: Ethical Considerations</Card.Link>. I have since updated it to include a disclaimer about this practice.
              </Card.Text>
              </Card.Body>
            </Card> 
          </Col>
        </Row>
      </div>
    );
  }
}

export default ResearchPage;
